var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenefitRiskManagement2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.73945 9.99072C1.88245 8.63672 2.21645 6.25772 2.92345 4.21972C3.28345 3.17772 3.72545 2.27872 4.24745 1.65272C4.76145 1.03672 5.30245 0.740724 5.89945 0.740724C6.49745 0.740724 7.03845 1.03672 7.55145 1.65272C8.07445 2.27872 8.51545 3.17772 8.87645 4.21972C9.58345 6.25772 9.91645 8.63672 10.0594 9.99072H11.5684L11.5604 9.91372C11.4184 8.54272 11.0714 5.97372 10.2934 3.72872C9.90545 2.60872 9.39245 1.51672 8.70345 0.691724C8.54786 0.503953 8.37874 0.327816 8.19745 0.164724C7.59706 0.048671 6.98694 -0.00959519 6.37545 -0.00927604H5.42345C4.80045 -0.00927604 4.19245 0.050724 3.60345 0.164724C3.42146 0.327743 3.25168 0.503882 3.09545 0.691724C2.40745 1.51672 1.89445 2.60872 1.50545 3.72872C0.727445 5.97272 0.380446 8.54272 0.239446 9.91372L0.231445 9.99072H1.73945Z",
    fill: "url(#paint0_linear_3443_12540)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73945 9.99072C1.88245 8.63672 2.21645 6.25772 2.92345 4.21972C3.28345 3.17772 3.72545 2.27872 4.24745 1.65272C4.76145 1.03672 5.30245 0.740724 5.89945 0.740724C6.49745 0.740724 7.03845 1.03672 7.55145 1.65272C8.07445 2.27872 8.51545 3.17772 8.87645 4.21972C9.58345 6.25772 9.91645 8.63672 10.0594 9.99072H11.5684L11.5604 9.91372C11.4184 8.54272 11.0714 5.97372 10.2934 3.72872C9.90545 2.60872 9.39245 1.51672 8.70345 0.691724C8.54786 0.503953 8.37874 0.327816 8.19745 0.164724C7.59706 0.048671 6.98694 -0.00959519 6.37545 -0.00927604H5.42345C4.80045 -0.00927604 4.19245 0.050724 3.60345 0.164724C3.42146 0.327743 3.25168 0.503882 3.09545 0.691724C2.40745 1.51672 1.89445 2.60872 1.50545 3.72872C0.727445 5.97272 0.380446 8.54272 0.239446 9.91372L0.231445 9.99072H1.73945Z",
    fill: "white",
    fillOpacity: 0.17
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_12540",
    x1: 11.5684,
    y1: -0.00927869,
    x2: -0.320348,
    y2: 0.735102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitRiskManagement2);
export default __webpack_public_path__ + "static/media/icon-benefit--risk-management2.293b73391b9f0a69dd1b04a3da7a35d7.svg";
export { ForwardRef as ReactComponent };